import React, { useEffect } from "react";
import BlogCard from "./BlogCard";
import blogData from "./blogData";
import "./blog.css";
import AOS from "aos";
import "aos/dist/aos.css";

const BlogList = () => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <>
      {/* HEADER */}
      <section className="blog-header">
        <div className="blog-circle yellow" />
        <div className="blog-circle teal" />
        <div className="blog-circle pink" />

        <div className="container">
          <h1 data-aos="fade-up" class="blog-heading">Blogs</h1>
          <p data-aos="fade-up" data-aos-delay="200">
            Insights, strategies, and updates from SMS marketing experts
          </p>
        </div>
      </section>

      {/* BLOG GRID */}
      <section className="py-5">
        <div className="container">
          <div className="row">
            {blogData.map((blog, index) => (
              <div
                key={blog.id}
                className="col-lg-4 col-md-6 mb-4"
                data-aos={
                  index % 3 === 0
                    ? "fade-up"
                    : index % 3 === 1
                      ? "fade-right"
                      : "fade-left"
                }
              >
                <BlogCard blog={blog} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogList;
